import PropTypes from 'prop-types';
import React from 'react';
import SalePromotion from 'components/contentBlocks/SalePromotion';
import colors from 'config/theme/colors';
import decodeHTMLEntities from '@nwg/core-web/utils/decodeHTMLEntities';

// Pure CMS data transformation before we send it to the "real" block!
const SalePromotionBlock = ({ content = {}, moduleTextColor = '' }) => {
    const { heading, revolving_heading: revolving } = content;

    // Transform color data
    const ligthTheme = moduleTextColor === 'white';
    const textColor = ligthTheme ? colors.white : colors.black;

    return <SalePromotion heading={decodeHTMLEntities(heading)} revolving={revolving} textColor={textColor} />;
};

SalePromotionBlock.propTypes = {
    content: PropTypes.shape({
        heading: PropTypes.string,
        'revolving_heading': PropTypes.bool,
    }).isRequired,
    moduleTextColor: PropTypes.string,
};

export default SalePromotionBlock;
